import React from 'react';

function IconPreview() {
  return (
    <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M15.078 7.36255V6.95817C15.078 3.12351 11.9007 0 8 0C4.09929 0 0.921986 3.12351 0.921986 6.95817V7.36255C0.368794 7.79482 0 8.4502 0 9.18924V11.6574C0 12.9402 1.06383 14 2.38298 14H3.48936C3.88652 14 4.21277 13.6793 4.21277 13.2888V7.57171C4.21277 7.18127 3.88652 6.86056 3.48936 6.86056H2.38298C2.38298 6.86056 2.36879 6.86056 2.35461 6.86056C2.41135 3.83466 4.92199 1.39442 8 1.39442C11.078 1.39442 13.5887 3.83466 13.6454 6.86056C13.6454 6.86056 13.6312 6.86056 13.617 6.86056H12.5106C12.1135 6.86056 11.7872 7.18127 11.7872 7.57171V13.2888C11.7872 13.6793 12.1135 14 12.5106 14H13.617C14.922 14 16 12.9542 16 11.6574V9.18924C16 8.43626 15.6312 7.78088 15.078 7.36255Z" fill="white"/>
    </svg>
  )
}

export default IconPreview;
